export enum ETipoRelatorioRentabilidadeEmpresa {
    Diaria = 1,
    Mensal = 2,
}
